import { useEffect } from 'react';

const useLockBodyScroll = (lock: boolean) => {
    useEffect(() => {
        if (lock) {
            document.getElementsByTagName('html')[0].classList.add('lock');
        } else {
            document.getElementsByTagName('html')[0].classList.remove('lock');
        }
    }, [lock]);
};

export default useLockBodyScroll;
